import { QueryCache, QueryClient, QueryClientProvider, QueryOptions } from '@tanstack/react-query'
import * as React from 'react'

const defaultQueryFn = async ({ queryKey }: QueryOptions) => {
  const response = await fetch(queryKey?.[0] as string, {
    cache: 'no-store',
  })
  const data = await response.json()
  return data
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFn,
    },
  },
  queryCache: new QueryCache({
    onError: error => {
      // TODO: handle error
      // eslint-disable-next-line no-console
      console.log(error)
    },
  }),
})

function ReactQueryContext({ children }: { children: React.ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}

export default ReactQueryContext
